<template>
  <div :class="bem()">
    <ul :class="bem('parts')">
      <template
        v-for="part in parts"
        :key="part.partName"
      >
        <li
          :class="[bem('parts-item')]"
          :data-testId="lensTechTestId(part)"
        >
          <div>
            <span
              v-if="part.partType === 'Lenses'"
              :class="bem('parts-lens')"
            >
              <!-- eslint-disable vue/no-v-html -->
              <span v-html="getLensChoiceName(part)" />
            </span>
            <span
              v-else
              v-html="getChoiceName(part)"
            />
            <!-- eslint-enable vue/no-v-html -->

            <span v-if="part.partName === 'Lenses' && hasColourPart">
              {{ ' ' + lensColour + ' ' }}
            </span>
            <span>
              {{ ' ' + part.partName + ' ' }}
            </span>
          </div>
        </li>
      </template>
    </ul>
  </div>
</template>

<script setup lang="ts">
const bem = useBEM('CartItemPartsBreakdown')

interface Props {
  customisedProduct: {
    choicesForDisplay: any
    baseSKU: string
  }
}

interface Part {
  optionTechCode: string
  optionTechDisplayTitle: string
  choiceName: string
  partName: string
  swatch: object
}

const props = defineProps<Props>()

const parts = computed(() => {
  return props.customisedProduct.choicesForDisplay.filter(
    (part: Part) => part.partName !== 'Colour'
  )
})

const lensColour = computed(() => {
  return props.customisedProduct.lensChoice?.nameWithoutLensTech
})

const hasColourPart = computed(() => {
  return (
    props.customisedProduct.choicesForDisplay.findIndex(
      (part) => part.partName === 'Colour'
    ) > -1
)
})

function getLensChoiceName(part: Part) {
  return part?.optionTechDisplayTitle
    ? part?.optionTechDisplayTitle
    : part?.choiceName
}

function getChoiceName(part) {
  switch (part.partName || '') {
    case 'currency':
      return $tcs(part.choiceValue)
    case 'Lenses':
      return `${getLensChoiceName(part)}`
    case 'Colour':
      return `${getLensChoiceName(part)} ${lensColour.value}`
    default:
      return part.choiceName
  }
}

function lensTechTestId(part: Part) {
  return part?.optionTechCode
    ? `cart-item-lens-tech-${part?.optionTechCode}`
    : false
}
</script>

<style lang="postcss" scoped>
.CartItemPartsBreakdown__parts {
  @apply flex flex-col;
}

.CartItemPartsBreakdown__parts-item {
  @apply flex items-center gap-1 capitalize order-1
    font-thin text-[11px] md:text-[12px] text-grey-500;
}

.CartItemPartsBreakdown__parts-swatch-container {
  @apply relative h-3 w-3 pointer-events-none;
}

.CartItemPartsBreakdown__part-item-prefix {
  @apply normal-case text-grey-600;
}

.CartItemPartsBreakdown__parts-lens {
  @apply after:content-['_'];
}
</style>
